import styled from 'styled-components';

export const WalletButtonNotificationBell = styled.div`
  position: absolute;
  top: -7px;
  left: -7px;
`;
